import React from 'react';

import styled from '@emotion/styled';

interface ITableDetails {
  RightRevealComponent: (...args: any[]) => any;
  tableDetailsData: any;
  showTableDetails: boolean;
  setShowTableDetails: (...args: any[]) => void;
}

export const TableDetails: React.FC<ITableDetails> = ({
  tableDetailsData,
  showTableDetails,
  setShowTableDetails,
  RightRevealComponent,
}) => {
  return (
    <>
      <DetailsContainer className={showTableDetails ? 'showDetails' : ''}>
        {RightRevealComponent && (
          <RightRevealComponent
            data={tableDetailsData}
            onClickHandler={() => {
              setShowTableDetails(false);
            }}
          />
        )}
      </DetailsContainer>
      <CloseArea
        className={!showTableDetails ? 'clear' : ''}
        onClick={() => {
          setShowTableDetails(false);
        }}
      ></CloseArea>
    </>
  );
};

const CloseArea = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  /* border: 2px solid yellow; */
  /* background-color: red; */

  &.clear {
    display: none;
  }
`;

const DetailsContainer = styled.div`
  z-index: 1001;
  display: flex;
  padding: 0px;
  padding-top: 2.25rem;
  width: 0;
  height: 100vh;
  background-color: white;
  /* background-color: ${({ theme }) => theme.palette.primaryBgColor}; */
  box-shadow: 0 0.3rem 0.8rem -0.2rem ${({ theme }) => theme.palette.shadowColor};
  position: fixed;
  top: 0;
  right: 0;
  overflow-x: auto;
  transition: all 0.2s ease;

  &.showDetails {
    /* border: 6px solid green; */
    width: 26.75rem;
    padding: 2rem;
    padding-top: 2.25rem;
  }
`;
